export default {
  '79dd431d35b370210a3dbeb1bb653d43': 'Fióknév',
};
